<template>
    <div class="bikes-list">
        <template>
            <bike-tile v-for="bikeId in list" :key="bikeId" :bikeId="bikeId" />
            <infinite-loading class="infinite-loading"
                              @infinite="infiniteHandler"
                              spinner="circles"
                              style="margin-left: auto; margin-right: auto"
                              ref="infiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </template>
    </div>
</template>
<script>
    // components
    import BikeTile from "./BikeTile.vue";
    import InfiniteLoading from "vue-infinite-loading";

    // css
    import "./Bikes.scss";

    export default {
        name: "BikeTileList",
        props: {
            bikesIds: {
                type: Array,
                required: true,
            },
            bikesCount: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        data() {
            return {
                page: 2,
                list: [],
                areElementsRendered: false
            };
        },
        watch: {
            //watch changes on bikesIds prop
            bikesIds: {
                deep: true,
                immediate: true,
                async handler() {
                    // reset page number
                    this.page = 2;
                    // get first 9 bikes
                    await this.getFirstBikes();
                    // reset state of infinite handler
                    if (this.list.length) {
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
                    }
                },
            },
        },
        methods: {
            // fired when infinite handler emits @infinite.
            infiniteHandler($state) {
                // load next 9 bikes
                const result = this.getNextBikes(this.page);

                if (result.length) {
                    if (this.areElementsRendered == true) {
                        this.page += 1;
                        this.areElementsRendered = false;
                        //this.$set(this.list, this.list.length, ...result);
                        this.list.push(...result);
                        this.$parent.$nextTick(() => {
                            setTimeout(() => {
                                this.areElementsRendered = true;
                                $state.loaded();
                            }, 60);
                        })
                    } else {
                        $state.loaded();
                    }
                } else {
                    // if there are no more bikes
                    $state.complete();
                }
            },
            getNextBikes(page) {
                // return next 9 bikes depending of page number
                return this.bikesIds.filter(
                    (bike, idx) => idx >= (page - 1) * 9 + 1 && idx <= (page - 1) * 9 + 9
                );
            },
            // get first 9 bikes
            async getFirstBikes() {
                this.list = this.bikesIds.filter((bike, idx) => idx <= 9);
                this.$nextTick(() => {
                    this.areElementsRendered = true;
                })
            },
        },
        mounted() {
            //this.getFirstBikes();
        },
        components: {
            BikeTile,
            InfiniteLoading,
        },
    };
</script>
<style scoped>
.infinite-loading {
  justify-content: center;
}
</style>
